export default {
  menuList: (state) => state.app.menuList,
  token: (state) => state.app.token,
  siderType: (state) => state.app.siderType,
  lang: (state) => state.app.lang,
  // 用户相关
  userInfo: (state) => state.app.userInfo, // 用户信息
  isPlatform: (state) => state.app.isPlatform, // 是否平台账号
  isServiceStation: (state) => state.app.isServiceStation, // 是否服务站账号
  isWarehouse: (state) => state.app.isWarehouse, // 是否仓储中心账号
  storeId: (state) => state.app.storeId // 服务站id
}
